export const columnHeader = [
  // {
  //   key: 'id', name: '#', type: 'text', system: true, filter: true, required: false
  // },
  {
    key: 'name', name: 'Name', type: 'text', system: false, filter: true, required: true
  },
  // {
  //   key: 'mobile', name: 'Mobile', type: 'text', system: false, filter: true, required: false
  // },
  // {
	// key: 'url', name: 'Url', type: 'text', system: false, filter: true, required: false
  // },
  // {
	// key: 'info', name: 'Information', type: 'text', system: false, filter: true, required: false
  // },
  // {
	// key: 'users', name: 'Users', type: 'text', system: true, filter: true, required: false
  // },
  {
	key: 'actions', name: '', type: 'actions', system: true, filter: false
  }
];